<template>
  <div class="p-grid p-fluid p-justify-between">
    <div class="p-col search-row-data">
      <span class="shorten-caption" :title="captionHint">{{ caption }}</span>
      <span class="shorten-caption-addition">&nbsp;{{ captionAddition }}</span>
    </div>
    <div class="p-col-1 row-button">
      <Button
          class="p-button-secondary"
          icon="pi pi-folder-open"
          v-on:click="openDialog"
          :disabled="disabled"
      ></Button>
    </div>
    <Dialog
        :style="{ width: '50vw', height: '50vw' }"
        :visible.sync="dialogVisible"
        class="my-dialog"
        modal
    >
      <template #header>
        {{ translate("selection.dialog.caption") }}
      </template>
      <div class="p-grid">
        <div class="p-col-4">
          <div class="p-inputgroup">
            <InputText
                v-model="newProfileName"
                :placeholder="translate('placeholder.new.profilename')"
            />
            <Button
                :disabled="createProfileInActive"
                class="p-button-success"
                icon="pi pi-plus"
                v-on:click="addProfileClick"
            ></Button>
          </div>
          <DataTable
              :selection.sync="selectedProfile"
              :value="getProfiles"
              dataKey="id"
              selectionMode="single"
          >
            <Column field="profileName">
              <template #header>
                <div>{{ translate("profilename") }}</div>
              </template>
            </Column>
          </DataTable>
        </div>
        <div class="p-col-8">
          <DataTable
              :filters="filters"
              v-bind:key="tableKey"
              :selection.sync="tableSelection"
              :value="options"
              dataKey="id"
              selectionMode="multi"
          >
            <Column headerStyle="width: 3em" selectionMode="multiple"></Column>
            <Column :header="translate('header.label')" field="label">
              <template #filter>
                <InputText
                    type="text"
                    v-model="filters['label']"
                    class="p-column-filter"
                    :placeholder="translate('placeholder.no.filter')"
                ></InputText>
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
      <template #footer>
        <div class="p-grid p-justify-between">
          <div class="p-col-3">
            <Button
                :disabled="selectedProfile == null"
                :label="translate('label.remove.profile')"
                class="p-button-danger"
                icon="pi pi-minus"
                style="text-align: left"
                v-on:click="removeProfileClick"
            ></Button>
          </div>
          <div class="p-col-9">
            <Button
                :disabled="selectedProfile == null"
                :label="translate('label.save.profile')"
                class="p-button-warning"
                icon="pi pi-save"
                v-on:click="saveProfileClick"
            />
            <Button
                :label="translate('button.cancel')"
                class="p-button-secondary"
                icon="pi pi-times"
                v-on:click="cancelClick"
            />
            <Button
                :label="translate('button.apply')"
                icon="pi pi-check"
                v-on:click="applyClick"
            />
          </div>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import SearchFieldService from "../services/searchfield.service";
import TranslateService from "../services/translate.service";
import _ from "lodash";

export default {
  name: "DynamicListSelect",
  props: {
    uniqueId: Number,
    options: {
      type: Array,
      required: false,
    },
    loading: Boolean,
    fieldName: String,
    disabled: Boolean,
  },
  data() {
    return {
      filters: {},
      newProfileName: "",
      selectedProfile: null,
      dialogVisible: false,
      // tableSelection: [],
      tableSelection: {},
      tableKey: 0,

      fieldValue: [],
      shortText: {shortText: "", descriptionText: ""},
    };
  },
  methods: {
    ...mapActions("search", ["setData"]),
    ...mapActions("wizard", ["addProfile", "removeProfile", "activateTable"]),
    translate(message) {
      return TranslateService.translateMessage(message);
    },
    applyClick() {
      // let search = this.objectToSearchString(this.fieldValue);
      // console.log("Before Apply: " + JSON.stringify(this.fieldValue));

      let list = this.selectedIdList;
      this.loadShortText(list);

      this.setData({uniqueId: this.uniqueId, data: list});
      this.dialogVisible = false;
    },
    cancelClick() {
      this.dialogVisible = false;
    },
    loadShortText(search) {
      SearchFieldService.loadDisplayText(this.fieldName, search).then((r) => {
        this.shortText = r.data;
      });
    },
    objectToSearchString(list) {
      return JSON.stringify(list);
    },
    openDialog() {
      this.selectedProfile = null;
      this.activateTable(this.fieldName);

      let sel = [];

      for (let val of this.fieldValue) {
        let obj = this.options.filter((v) => v.id === val);
        sel.push(obj[0]);
      }

      console.log("TableSelection: ", sel);
      this.dialogVisible = true;
      // this.$nextTick(() => {
      this.tableSelection = sel;
      // this.tableKey++;
      // this.$forceUpdate();
      // })
    },
    load() {
      // Val ist ein ARRAY!!
      let val = this.getData(this.uniqueId);

      if (val[0] !== "") {
        this.fieldValue = val;
        this.loadShortText(val);
      }
    },
    addProfileClick() {
      let search = this.selectedIdList;
      let profile = {
        profileName: this.newProfileName,
        fieldName: this.fieldName,
        profileContent: search,
      };
      this.newProfileName = "";
      this.addProfile(profile).then((r) => {
        this.selectedProfile = r;
      });
    },
    saveProfileClick() {
      let profile = _.cloneDeep(this.selectedProfile);
      _.set(profile, "profileContent", this.selectedIdList);
      this.newProfileName = "";
      this.addProfile(profile).then((r) => {
        this.selectedProfile = r;
      });
    },
    loadProfile() {
      if (this.selectedProfile != null) {
        this.newProfileName = "";

        let sel = [];
        for (let val of _.get(this.selectedProfile, "profileContent", [])) {
          let obj = this.options.filter((v) => v.id === val);
          sel.push(obj[0]);
        }
        this.tableSelection = sel;
      }
    },
    removeProfileClick() {
      if (this.selectedProfile != null) {
        this.removeProfile(this.selectedProfile).then(() => {
          this.selectedProfile = null;
        });
      }
    },
    clearSelection() {
      if (this.newProfileName !== "") {
        this.selectedProfile = null;
      }
    },
  },
  watch: {
    newProfileName() {
      this.clearSelection();
    },
    selectedProfile() {
      this.loadProfile();
    },
  },
  computed: {
    ...mapGetters("search", ["getData"]),
    ...mapGetters("wizard", ["getProfiles"]),
    caption() {
      return this.shortText.shortText;
    },
    captionAddition() {
      if (this.shortText.additionCount) {
        return " (+" + this.shortText.additionCount + " more)";
      }
      return null;
    },
    captionHint() {
      return this.shortText.descriptionText;
    },
    createProfileInActive() {
      // return !((this.newProfileName !== '') && (this.fieldValue != null));
      return this.newProfileName.trim() === "";
    },
    selectedIdList() {
      let list = [];
      for (let key of this.tableSelection) {
        console.log("Key: ", key);

        if (key !== undefined) {
          if (typeof key === "string") {
            list.push(key);
          } else {
            list.push(key.id);
          }
        }
      }
      return list;
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<style scoped>
.row-button {
  text-align: right;
  margin-right: 15px;
}

.my-dialog .p-dialog .p-dialog-footer {
  /*.my-dialog .p-dialog-footer {*/
  text-align: left;
}

</style>
